import { useState, useRef, useEffect } from "react";
import "./payments.css"; // Import the CSS file
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import { useSelector } from "react-redux";
import axios from "axios";
import Logo from "../test.png";
import AssuredWorkloadIcon from "@mui/icons-material/AssuredWorkload";

let transactionsData, staffData;

export default function Payments() {
  const { accessType } = useSelector((state) => state.clientFunction);
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const staffData = useSelector((state) => state.clientFunction?.companiesDB);
  const { registerData } = useSelector((state) => state.terminalActions);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  async function apiGetSales() {
    setLoading(true);
    await axios
      .get(
        `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/register/${registerData?.registerId}/client/${companyData?.clientId}/getRegSoldItem`,
      )
      .then((response) => {
        transactionsData = response.data.regTransactions;
        console.log("Payments Trans-Data: ", transactionsData);
        if (response.data.status === 201) {
          setLoading(false);
        } else {
          enqueueSnackbar(`${response.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            ContentProps: {
              style: { fontSize: "16px", fontWeight: "bold" },
            },
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        enqueueSnackbar(`error: something went wrong!`, {
          variant: "error",
          autoHideDuration: 3000,
          ContentProps: {
            style: { fontSize: "16px", fontWeight: "bold" },
          },
        });
        console.log(error?.code || "REQUEST_FAILED");
        setLoading(false);
      });
  }

  // SUMMATION OF THE ENTIRE TRANSACTIONS FUCTIONS
  function getSalesSummary(transactionsData = []) {
    const paymentMethods = [
      "cash",
      "credit",
      "debit",
      "gift",
      "account",
      "cheque",
      "multiple-pay",
    ];

    const summary = {
      totalItemsSold: 0,
      totalPaymentsMade: 0,
      totalDebts: 0,
      paymentMethods: {},
    };

    paymentMethods.forEach((method) => {
      summary.paymentMethods[method] = {
        transactions: 0,
        amount: 0,
      };
    });

    transactionsData.forEach((transaction) => {
      summary.totalItemsSold +=
        transaction.soldItems?.reduce(
          (total, item) => total + Number(item.soldQuantity || 0),
          0,
        ) || 0;

      const amount = Number(transaction.totals?.subtotal || 0);
      const method = transaction.payment?.method?.toLowerCase();

      if (summary.paymentMethods[method]) {
        summary.paymentMethods[method].transactions++;
        summary.paymentMethods[method].amount += amount;
      }

      if (method === "credit") {
        summary.totalDebts += amount;
      } else {
        summary.totalPaymentsMade += amount;
      }
    });

    return summary;
  }
  // Call it using your array
  const salesSummary = getSalesSummary(transactionsData);

  console.log(salesSummary);
  // SESSION FUNCTIONS

  const diffMs = Date.now() - new Date(registerData?.timeInn).getTime();

  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

  const sessionTime = `${hours}h ${minutes}m`;

  const sessionStart = new Date(registerData?.timeInn);
  const from = sessionStart.toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });

  const to = new Date().toLocaleString(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  });

  const theSession = `${from} - ${to}`;
  useEffect(() => {
    apiGetSales();
  }, [registerData?.registerId, companyData?.clientId]);
  return (
    <div id="paymentsTransactions" className="paymentsWrapper fx-cl space3">
      <div className="payments flex-container">
        {/* First Container */}
        <div className="payments-first-container">
          <div className="payments-left-side fx-ac space2">
            <figure className="paymentsLogo">
              <AssuredWorkloadIcon style={{ fontSize: "4.7rem" }} />
            </figure>
            <div className="fx-cl space1">
              <h1>Payments</h1>

              <p>Respresentive: {registerData?.representiveName}</p>
            </div>
          </div>
          <div className="payments-right-side fx-cl space1">
            <p>{registerData?.location?.name} </p>
            <p>{registerData?.location?.address}</p>
          </div>
        </div>

        {/* Second Container */}
        <div className="payments-second-container fx-jb space3">
          <div className="payments-inner-div">
            <div className=" fx-cl space1">
              <h3>Operation Details</h3>
              <div className="fx-cl spacem">
                <p>
                  <strong>Register Reference ID: </strong>
                  {registerData?.registerId}
                </p>
                <p>
                  <strong>Items sold: </strong>
                  {salesSummary.totalItemsSold}
                </p>
                <p>
                  <strong>Total payments: </strong> ₦
                  {salesSummary.totalPaymentsMade.toLocaleString()}
                </p>
                <p>
                  <strong>Debts: </strong> ₦
                  {salesSummary.totalDebts.toLocaleString()}
                </p>
                <p>
                  <strong>Session: </strong>
                  {theSession}
                </p>
                <p>
                  <strong>Hours: </strong> {sessionTime}
                </p>
              </div>
            </div>
          </div>
          <div className="payments-inner-div">
            <div className=" fx-cl space1">
              <h3>User info:</h3>
              <div className="fx-cl spacem">
                <p>
                  <strong>Staff ID: </strong> {registerData?.representiveId}
                </p>
                <p>
                  <strong>Username: </strong>
                  {registerData?.representiveUserName}
                </p>

                <p>
                  <strong>Location: </strong> {registerData?.location?.name}
                </p>
                <p>
                  <strong>Phone No.: </strong>{" "}
                  {registerData?.representiveNumber}
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Third Container */}
        <div className="payments-third-container fx-cl space3">
          <div className="fx-cl">
            <h3>Payment details</h3>
            <p>Overview of payments and outstanding balances</p>
          </div>
          <table className="paymentsTable">
            <thead style={{ textAlign: "left" }}>
              <tr>
                <th>Serial No.</th>
                <th>Items</th>
                <th>Discription</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ display: "flex" }}>
                <h2>Payment Methods</h2>
              </tr>

              {Object.entries(salesSummary.paymentMethods).map(
                ([method, data], index) => (
                  <tr key={method}>
                    <td>{String(index + 1).padStart(2, "0")}</td>
                    <td>
                      <strong>
                        {method.replace(/\b\w/g, (char) => char.toUpperCase())}
                      </strong>
                    </td>
                    <td>{data.transactions} transaction(s)</td>
                    <td>₦{data.amount.toLocaleString()}</td>
                  </tr>
                ),
              )}

              <tr>
                <td></td>
                <td>
                  <strong>TOTAL</strong>
                </td>
                <td>-</td>
                <td>
                  <strong>
                    ₦{salesSummary.totalPaymentsMade.toLocaleString()}
                  </strong>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
